import { useNavigate } from 'react-router-dom';

import { useDispatch } from '@/lib/redux/useDispatch';
import { useSelector } from '@/lib/redux/useSelector';
import { actions } from '@/redux/actions';
import { userSelector } from '@/redux/user/selectors';

import { CompanyInfo } from './components/CompanyInfo';
import type { ICompany, IUser } from '@enl/type-definitions';

type IOnboardingPayload = {
  company: Omit<ICompany, 'branding'>;
  user: Pick<IUser, 'firstName' | 'lastName'>;
};

export const Onboarding = () => {
  const dispatch = useDispatch();
  const user = useSelector(userSelector);
  const navigate = useNavigate();

  return (
    <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-sm">
        <CompanyInfo
          user={user || {}}
          onSubmit={async (d: IOnboardingPayload) => {
            const resp = await dispatch(actions.updateMe(d.user));

            if (resp.type.includes('fulfilled')) {
              const companyResp = await dispatch(actions.createCompany(d.company));
              if (companyResp.type.includes('fulfilled')) {
                // Redirect to the next page
                await dispatch(actions.getMe());
                navigate('/');
              }
            }
            // await dispatch(actions.createCompany(d.company));
          }}
        />
      </div>
    </div>
  );
};
